import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './loader.scss';

class Loader extends Component {
    constructor(props) {
        super(props);
        this.enableLoader = this.enableLoader.bind(this);
        this.state = { displayLoader: false };
        this.timer = setTimeout(this.enableLoader, 400);
    }

    componentWillUnmount() {
        clearTimeout(this.timer);
    }

    enableLoader() {
        this.setState({ displayLoader: true });
    }
    render() {
        const visible = this.state.displayLoader && this.props.visible;
        return (
            <div className={'bk-loader-fullscreen' + (visible ? '' : ' hide')}>
                <div className="bk-loader-cube-grid">
                    <div className="bk-loader-cube bk-loader-cube1" />
                    <div className="bk-loader-cube bk-loader-cube2" />
                    <div className="bk-loader-cube bk-loader-cube3" />
                    <div className="bk-loader-cube bk-loader-cube4" />
                    <div className="bk-loader-cube bk-loader-cube5" />
                    <div className="bk-loader-cube bk-loader-cube6" />
                    <div className="bk-loader-cube bk-loader-cube7" />
                    <div className="bk-loader-cube bk-loader-cube8" />
                    <div className="bk-loader-cube bk-loader-cube9" />
                </div>
            </div>
        );
    }
}
Loader.propTypes = {
    visible: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
    visible: state.fetching.length > 0,
});

export default connect(mapStateToProps)(Loader);
